import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import * as moment from 'moment';
import { ToasterService } from 'angular2-toaster';

import { LoanService } from '../../shared-component/service/loan/loan.service';
import { environment } from '../../../environments/environment';
import { applicationStatus as APPLICATION_STATE } from '../../shared-component/compare/compare.service'

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})

export class DetailsComponent implements OnInit {

  public details: FormGroup;

  private loanId: number;
  public todayDate: any;
  public resData: any = {};
  public showNumber: boolean = false;
  public showOTPText: boolean = false;
  public requiredOTP: boolean = true;
  public showSamePhoneNumberError: boolean = false;
  public showPatternPhoneNumberError: boolean = false;
  public showDetailsPage: boolean = false;
  public resendOTP: boolean = false;
  public saveMobileNumber: string;
  public saveEmail: string;
  public cxNameAsPerPan: string;
  public flag: boolean = false;

  public formFieldsOnOldCustomer = [
    'customerId'
  ];

  public formFieldsOnNewCustomer = [
    {
      name: 'aadharGender',
      pattern: ''
    }, {
      name: 'salutation',
      pattern: ''
    }, {
      name: 'firstName',
      pattern: /^[A-Za-z ]+$/
    },
    {
      name: 'lastName',
      pattern: /^[A-Za-z ]*$/
    }, {
      name: 'email',
      pattern: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]{2,3})*$/
    }, {
      name: 'dob',
      pattern: /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/
    }, {
      name: 'mobile',
      pattern: /^\d{10}$/
    }, {
    }, {
      name: 'spouseMobile',
      pattern: /^\d{10}$/
    }, {
    }, {
      name: 'motherMobile',
      pattern: /^\d{10}$/
    }, {
    }, {
      name: 'fatherMobile',
      pattern: /^\d{10}$/
    }, {
      name: 'otp',
      pattern: /^\d{6}$/,
    }, {
      name: 'alternateMobile',
      pattern: /^\d{10}$/,
    }, {
      name: 'panNumber',
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
    }, {
      name: 'fatherhusbandName',
      pattern: /^[A-Za-z ]+$/
    }, {
      name: 'maritalStatus',
      pattern: ''
    }
  ];

  public oldCustomerData = [
    {
      name: 'aadharGenderOld',
      pattern: ''
    }, {
      name: 'salutationOld',
      pattern: ''
    }, {
      name: 'firstNameOld',
      pattern: ''
    }, {
      name: 'lastNameOld',
      pattern: ''
    }, {
      name: 'emailOld',
      pattern: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]{2,3})*$/
    }, {
      name: 'dobOld',
      pattern: /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/
    }, {
      name: 'mobileOld',
      pattern: /^\d{10}$/
    }, {
      name: 'alternateMobileOld',
      pattern: /^\d{10}$/,
    }, {
      name: 'panNumberOld',
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
    }, {
      name: 'fatherhusbandNameOld',
      pattern: /^[A-Za-z ]+$/
    }, {
      name: 'maritalStatusOld',
      pattern: ''
    }
  ];

  public dobMask = [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[1-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  public datePickerData = new Subject();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private toasterService: ToasterService,
    private loanService: LoanService
  ) {
    this.datePickerData.subscribe((value: NgbDate) => {
      const date = [
        value.day.toString().length === 1 ? `0${value.day}` : value.day.toString(),
        value.month.toString().length === 1 ? `0${value.month}` : value.month.toString(),
        value.year
      ].join('/');

      this.dob.setValue(date);
    });
  }

  public onInputFocus(event: any): void {
    const placeholder = event.target.getAttribute('real-placeholder');
    event.target.setAttribute('placeholder', placeholder);
  }

  public onInputBlur(event: any): void {
    event.target.setAttribute('placeholder', '');
    if (event.target.value !== '') {
      event.target.setAttribute('style', 'opacity:1;');
    }
  }

  ngOnInit() {
    this.details = this.fb.group({
      aadharGender: '',
      isExistingUser: ['0', Validators.compose([Validators.required])],
      alternateMobile: ['', Validators.compose([Validators.required, Validators.pattern(/^\d{10}$/)])],
      motherMobile: ['',Validators.compose([Validators.required, Validators.pattern(/^\d{10}$/)])],
      fatherMobile: ['',Validators.compose([Validators.required, Validators.pattern(/^\d{10}$/)])],
      spouseMobile: ['',Validators.compose([Validators.required, Validators.pattern(/^\d{10}$/)])],
    });

    this.formFieldsOnNewCustomer.forEach((o) => {
      if (this.details.get(o.name)) return;
      if (["lastName"].indexOf(o.name) > -1) {
        this.details.addControl(o.name, new FormControl(''));
        if (o.pattern) {
          this.details.get(o.name).setValidators([Validators.pattern(o.pattern)]);
        }
      } else {
        this.details.addControl(o.name, new FormControl('', Validators.compose([Validators.required])));
        if (o.pattern) {
          this.details.get(o.name).setValidators([Validators.required, Validators.pattern(o.pattern)]);
        }
      }

    });

    // Check to trigger PAN API once input field receives 10 digit value.
    // this.pan.valueChanges.subscribe(() => {
    //  if (this.pan.value && this.pan.value.toString().length === 10)
    //   this.verifyPan();
    // });

    // this.details.get('alternateMobile').setValidators([]);
    // this.details.get('alternateMobile').updateValueAndValidity();

    this.formFieldsOnOldCustomer.forEach(o => {
      this.details.removeControl(`${o}`);
    });

    this.mobile.valueChanges.subscribe(() => {
      if (this.resData.Customer.mobile === this.mobile.value) {
        this.requiredOTP = false;
        //this.details.get('otp').setValidators([]);
        //this.details.get('otp').updateValueAndValidity();
      }
      else {
        this.requiredOTP = true;
        // this.details.get('otp').setValidators([Validators.required]);
        //this.details.get('otp').updateValueAndValidity();
      }
      this.resendOTP = this.saveMobileNumber === this.mobile.value;
    });

    this.email.valueChanges.subscribe(() => {
      if (this.resData.Customer.email === this.email.value) {
        this.requiredOTP = false;
        //this.details.get('otp').setValidators([]);
        //this.details.get('otp').updateValueAndValidity();
      }
      else {
        this.requiredOTP = true;
        //this.details.get('otp').setValidators([Validators.required]);
        //this.details.get('otp').updateValueAndValidity();
      }
      this.resendOTP = this.saveEmail === this.email.value;
    });

    this.alternateMobile.valueChanges.subscribe(() => {
      this.showSamePhoneNumberError = false;
    });

    this.todayDate = {
      year: parseInt(moment().format('YYYY')) - 18,
      month: parseInt(moment().format('MM')),
      day: parseInt(moment().format('DD'))
    };

    this.isExistingUser.valueChanges.subscribe((res) => {
      if (res === '1') {
        if (!this.details.get('customerId')) {
          this.details.addControl('customerId',
            new FormControl('',
              Validators.compose([Validators.required])));
        }
        if (!this.details.get('sendCustomerIdInput')) {
          this.details.addControl('sendCustomerIdInput',
            new FormControl('', Validators.compose([Validators.pattern(/^\d{10}$/)])));
        }
        this.formFieldsOnNewCustomer.forEach((o) => {
          this.details.removeControl(o.name);
        });

      }
      else if (res === '0') {
        this.formFieldsOnNewCustomer.forEach((o) => {
          if (this.details.get(o.name)) return;
          this.details.addControl(o.name,
            new FormControl('', Validators.compose([Validators.required])));
          if (o.pattern) {
            this.details.get(o.name).setValidators([Validators.required, Validators.pattern(o.pattern)]);
          }
        });

        this.details.get('alternateMobile').setValidators([]);
        this.details.get('alternateMobile').updateValueAndValidity();

        this.formFieldsOnOldCustomer.forEach(o => {
          this.details.removeControl(`${o}`);
        });
        this.mobile.valueChanges.subscribe(() => {
          if (this.resData.Customer.mobile === this.mobile.value) {
            this.requiredOTP = false;
            // this.details.get('otp').setValidators([]);
            //this.details.get('otp').updateValueAndValidity();
          }
          else {
            this.requiredOTP = true;
            //this.details.get('otp').setValidators([Validators.required]);
            //this.details.get('otp').updateValueAndValidity();
          }
          this.resendOTP = this.saveMobileNumber === this.mobile.value;
        });
        this.email.valueChanges.subscribe(() => {
          if (this.resData.Customer.email === this.email.value) {
            this.requiredOTP = false;
            //this.details.get('otp').setValidators([]);
            //this.details.get('otp').updateValueAndValidity();
          }
          else {
            this.requiredOTP = true;
            this.details.get('otp').setValidators([Validators.required]);
            this.details.get('otp').updateValueAndValidity();
          }
          this.resendOTP = this.saveEmail === this.email.value;
        });
        this.alternateMobile.valueChanges.subscribe(() => {
          this.showSamePhoneNumberError = false;
        });
      }
    });
    this.activeRoute.data.subscribe((res: any) => {
      if (res.loanDetail && Object.keys(res.loanDetail).length) {
        this.resData = res.loanDetail;
        this.loanId = res.loanDetail.id;
        if(res.loanDetail.applicationStatus >= APPLICATION_STATE.USER_BASIC_DETAILS) this.flag = true;
        if (res.loanDetail && res.loanDetail.isExistingUser !== null) {
          this.details.patchValue({
            isExistingUser: res.loanDetail.isExistingUser ? '1' : '0'
          });
          if (res.loanDetail.Customer) {
            this.details.patchValue({
              aadharGender: res.loanDetail.Customer.aadharGender ? res.loanDetail.Customer.aadharGender : '',
              salutation: res.loanDetail.Customer.salutation ? res.loanDetail.Customer.salutation : '',
              firstName: res.loanDetail.Customer.firstName ? res.loanDetail.Customer.firstName : '',
              lastName: res.loanDetail.Customer.lastName ? res.loanDetail.Customer.lastName : '',
              fatherhusbandName: res.loanDetail.Customer.fatherhusbandName ? res.loanDetail.Customer.fatherhusbandName : '',
              spouseMobile: res.loanDetail.Customer.spouseMobile ? res.loanDetail.Customer.spouseMobile : '',
              maritalStatus: res.loanDetail.Customer.maritalStatus ? res.loanDetail.Customer.maritalStatus : '',
              email: res.loanDetail.Customer.email ? res.loanDetail.Customer.email : '',
              dob: res.loanDetail.Customer.dob
                ? moment(res.loanDetail.Customer.dob, 'YYYY-MM-DD').format('DD/MM/YYYY')
                : '',
              motherMobile: res.loanDetail.Customer.motherMobile ? res.loanDetail.Customer.motherMobile : '',
              fatherMobile: res.loanDetail.Customer.fatherMobile ? res.loanDetail.Customer.fatherMobile : '',
              mobile: res.loanDetail.Customer.mobile ? res.loanDetail.Customer.mobile : '',
              alternateMobile: res.loanDetail.Customer.alternateMobile ? res.loanDetail.Customer.alternateMobile : '',
              panNumber: res.loanDetail.Customer.panNumber ? res.loanDetail.Customer.panNumber : '',
            });
            this.requiredOTP = false;
          }
        }
      }
    });
  }

  get aadharGender() {
    return this.details.get('aadharGender');
  }

  get salutation() {
    return this.details.get('salutation');
  }

  get firstName() {
    return this.details.get('firstName');
  }

  get lastName() {
    return this.details.get('lastName');
  }

  get fatherhusbandName() {
    return this.details.get('fatherhusbandName');
  }

  get spouseMobile() {
    return this.details.get('spouseMobile');
  }

  get maritalStatus() {
    return this.details.get('maritalStatus');
  }
 
  get email() {
    return this.details.get('email');
  }

  get dob() {
    return this.details.get('dob');
  }

  get motherMobile() {
    return this.details.get('motherMobile');
  }

  get fatherMobile() {
    return this.details.get('fatherMobile');
  }

  get mobile() {
    return this.details.get('mobile');
  }

  get otp() {
    return this.details.get('otp');
  }

  get alternateMobile() {
    return this.details.get('alternateMobile');
  }

  get pan() {
    return this.details.get('panNumber');
  }

  get customerID() {
    return this.details.get('customerId');
  }

  get sendCustomerIdInput() {
    return this.details.get('sendCustomerIdInput');
  }

  get isExistingUser() {
    return this.details.get('isExistingUser');
  }

  get aadharGenderOld() {
    return this.details.get('aadharGenderOld');
  }

  get salutationOld() {
    return this.details.get('salutationOld');
  }

  get firstNameOld() {
    return this.details.get('firstNameOld');
  }

  get lastNameOld() {
    return this.details.get('lastNameOld');
  }

  get fatherhusbandNameOld() {
    return this.details.get('fatherhusbandNameOld');
  }

  get maritalStatusOld() {
    return this.details.get('maritalStatusOld');
  }

  get emailOld() {
    return this.details.get('emailOld');
  }

  get dobOld() {
    return this.details.get('dobOld');
  }

  get mobileOld() {
    return this.details.get('mobileOld');
  }

  get alternateMobileOld() {
    return this.details.get('alternateMobileOld');
  }

  get panNumberOld() {
    return this.details.get('panNumberOld');
  }

  panFormatValidator() {
    let inputPanValue = this.details.get('panNumber').value.toUpperCase();
    let pattern = /^(?:[A-Z]{1,5}|[A-Z]{5}[0-9]{1,4}|[A-Z]{5}[0-9]{4}[A-Z]{1})$/;

    if (pattern.test(inputPanValue)) {
      this.details.get('panNumber').setValue(inputPanValue)
      if (inputPanValue.length == 10) this.verifyPan();
    } else this.details.get('panNumber').setValue(inputPanValue.slice(0, -1))
    this.details.get('firstName').reset();
    this.details.get('lastName').reset();
    this.details.get('fatherhusbandName').reset();
  }

  calculateAge(): number {
    const dob = this.details.get('dob').value;
    if (!dob) return 0;

    const parts = dob.split('/');
    if (parts.length !== 3) return 0; 

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; 
    const year = parseInt(parts[2], 10);

    const birthDate = new Date(year, month, day);

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  onSubmit() {
    let data = {};
    let currentYear: any = moment(new Date()).format("YYYY");
    if ((currentYear - this.dob.value.split('/')[2]) > environment.customer_max_age) {
      this.details.get("dob").setErrors({ server: "Age should not be more than " + environment.customer_max_age + " years" });
      return;
    }
    let age = this.calculateAge();
    if (age >= 30) {
      data['motherMobile'] = null;
      data['fatherMobile'] = null;
    } else {
      data['motherMobile'] = this.motherMobile.value.toString();
      data['fatherMobile'] = this.fatherMobile.value.toString();
    }
    if (this.isExistingUser.value == '0') {
      data['isExistingUser'] = false;
      this.salutation.value == 'Dr' ? data['aadharGender'] = this.aadharGender.value : data['aadharGender'] = null;
      data['salutation'] = this.salutation.value;
      data['firstName'] = this.capitalize(this.firstName.value);
      data['lastName'] = this.capitalize(this.lastName.value);
      data['fatherhusbandName'] = this.capitalize(this.fatherhusbandName.value);
      data['maritalStatus'] = this.maritalStatus.value;
      data['email'] = this.email.value;
      data['dob'] = this.dob.value
        ? [this.dob.value.split('/')[2], this.dob.value.split('/')[1], this.dob.value.split('/')[0]].join('-')
        : '';
      data['mobile'] = this.mobile.value.toString();
      data['spouseMobile'] = this.maritalStatus.value === 'Married' ? this.spouseMobile.value.toString() : null;
      //if flag is true, meaning opt has already been verifed, send random otp for backend form validation
      data['otp'] = this.flag ? '234324' : this.otp.value;
      data['panNumber'] = this.pan.value;

      if (this.alternateMobile.value)
        data['alternateMobile'] = this.alternateMobile.value.toString();
    }

    this.loanService.basicInfo(data, this.loanId).subscribe(() => {
      this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}/residence-details`);
    }, (errors) => {
      debugger;
      for (let error of errors) {
        if (!this.details.get(error.field)) continue;
        this.details.get(error.field).setErrors({ server: error.message });
        this.toasterService.pop('error', '', error.message);
      }
    });
  }

  goToDetails() {
    if (this.showDetailsPage) {
      let data = {
        isExistingUser: true,
        customerId: this.customerID.value
      };
      if (this.alternateMobileOld.value)
        data['alternateMobile'] = this.alternateMobileOld.value.toString();

      if (this.panNumberOld.value)
        data['panNumber'] = this.panNumberOld.value.toString();

      this.loanService.basicInfo(data, this.loanId).subscribe(() => {
        this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}/residence-details`);
      }, (errors) => {
        for (let error of errors) {
          if (!this.details.get(error.field)) continue;
          this.details.get(error.field).setErrors({ server: error.message });
        }
      });
    } else {
      let data = {};
      if (this.isExistingUser.value == '1') {
        data['isExistingUser'] = true;
        this.formFieldsOnOldCustomer.forEach((o) => {
          data[o] = this.details.get(o).value;
        });
      }

      this.loanService.customerInfo(data, this.loanId).subscribe((res: any) => {
        this.showDetailsPage = true;
        this.oldCustomerData.forEach((o) => {
          if (this.details.get(o.name)) return;
          this.details.addControl(o.name,
            new FormControl(o.name === 'salutationOld' ? 'Mr' : '',
              Validators.compose([o.name !== 'alternateMobileOld' ? Validators.required : null])));
          if (o.pattern) {
            this.details.get(o.name).setValidators([Validators.required, Validators.pattern(o.pattern)]);
          }
        });
        this.oldCustomerData.forEach((o) => {
          if (o.name === 'alternateMobileOld') {
            this.details.get(o.name).setValidators([]);
          }
        });
        this.details.patchValue({
          aadharGenderOld: res.data.aadharGender ? res.data.aadharGender : '',
          salutationOld: res.data.salutation ? res.data.salutation : '',
          firstNameOld: res.data.firstName ? res.data.firstName : '',
          lastNameOld: res.data.lastName ? res.data.lastName : '',
          fatherhusbandNameOld: res.data.fatherhusbandName ? res.data.fatherhusbandName : '',
          maritalStatusOld: res.data.maritalStatus ? res.data.maritalStatus : '',
          emailOld: res.data.email ? res.data.email : '',
          dobOld: res.data.dob
            ? moment(res.data.dob, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '',
          mobileOld: res.data.mobile ? res.data.mobile : '',
          alternateMobileOld: res.data.alternateMobile ? res.data.alternateMobile : '',
          panNumberOld: res.data.panNumber ? res.data.panNumber : '',
        });
      }, (errors) => {
        for (let error of errors) {
          if (!this.details.get(error.field)) continue;
          this.details.get(error.field).setErrors({ server: error.message });
        }
      });
    }
  }

  goPrev() {
    this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}`);
  }

  closeFix(event, datePicker) {
    if (datePicker._model)
      this.datePickerData.next(datePicker._model);

    if (event.target.offsetParent == null)
      datePicker.close();
    else if (event.target.offsetParent.nodeName != 'NGB-DATEPICKER')
      datePicker.close();
  }

  sendOtp() {
    this.loanService.sendOtp({
      mobile: this.mobile.value.toString(),
      email: this.email.value,
      applicationId : this.loanId
    }).subscribe(() => {
      this.showOTPText = true;
      this.resendOTP = true;
      this.saveMobileNumber = this.mobile.value;
      this.saveEmail = this.email.value;
      this.toasterService.pop('success', 'OTP has been successfully sent to the   registered mobile number.');
    }, (errors) => {
      this.showOTPText = false;
      for (let error of errors) {
        if (!this.details.get(error.field)) continue;
        this.details.get(error.field).setErrors({ server: error.message });
      }
    });
  }

  sendCustomerId() {
    this.loanService.sendCustomerId({
      emailOrMobile: this.sendCustomerIdInput.value
    }).subscribe(() => {
    });
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray)
        ? this.getAllErrors(control)
        : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  capitalize(input) {
    if (input && input.trim()) {
      const trimmedInput = input.trim();
      const inputSplitBySpace = trimmedInput.split(" ");
      const capitalizedInputList = inputSplitBySpace.reduce((acc, val) => {
        return val ? acc.concat([val[0].toUpperCase() + val.slice(1, val.length)]) : acc;
      }, []);
      return capitalizedInputList.join(" ");
    }
    return input;
  }
  checkFormValidity() {
    let age = this.calculateAge();
    let aadharGender = true;
    this.salutation.value == 'Dr' && !this.aadharGender.value ? aadharGender = false : '';
    let motherNameRequired = age < 30;
    let fatherNameRequired = age < 30;
    let isMarried = this.maritalStatus.value === 'Married';
    return (this.salutation.value
      && this.pan.value
      && this.mobile.value
      && this.alternateMobile.valid
      && this.email.value
      && this.firstName.value
      && this.lastName.value
      && this.fatherhusbandName.value
      && this.maritalStatus.value
      && this.dob.value
      && this.mobile.value != this.alternateMobile.value
      && aadharGender && 
      (!motherNameRequired || this.motherMobile.value) && 
      (!fatherNameRequired || this.fatherMobile.value)
      && (!isMarried || this.spouseMobile.value));
  }

  verifyPan() {
    this.loanService.verifyPan({
      pan: this.pan.value
    }).subscribe((res: any) => {
      /* this.cxNameAsPerPan = res.data.name;
      let name = this.cxNameAsPerPan.split(" ");
      this.firstName.setValue("");
      this.lastName.setValue("");
      this.fatherhusbandName.setValue("");
      if (name.length == 1) {
        this.firstName.setValue(this.cxNameAsPerPan);
      } else {
        let lastName = name.pop();
        this.lastName.setValue(lastName);
        if (name.length > 1) {
          let fatherName = name.pop();
          this.fatherhusbandName.setValue(fatherName);
        }
        this.firstName.setValue(name.join(" "));
      }
      this.toasterService.pop('success', res.message); */
    }, (errors) => {
      for (let error of errors) {
        if (!this.details.get(error.field)) continue;
        this.details.get(error.field).setErrors({ server: error.message });
      }
    });
  }

 

  exchangeValue() {
    let fName = this.firstName.value;
    let lName = this.lastName.value;
    this.firstName.setValue(lName);
    this.lastName.setValue(fName);
  }

  verifyOtp() {
    this.loanService.verifyOtp({
      otp: this.otp.value,
      mobile: this.mobile.value
    }).subscribe((res: any) => {
      this.flag = res.data.flag;
      this.toasterService.pop('success', res.data.message);
    })
  }
}